import type { BrowserLocalCacheDriver, BrowserLocalCacheStoreName } from './types'

export type BrowserLocalCacheUserScopeClearResult = {
  userScope: string
  deletedCount: number
  storeCounts: Partial<Record<BrowserLocalCacheStoreName, number>>
}

export const BROWSER_LOCAL_CACHE_USER_SCOPED_STORES: BrowserLocalCacheStoreName[] = [
  'cache_entries',
  'entities',
  'task_center_items',
  'images',
  'sync_cursors',
  'mutation_journal',
  'performance_budget',
  'cache_events',
]

export const clearBrowserLocalCacheUserScope = async (
  driver: BrowserLocalCacheDriver,
  userScope: string
): Promise<BrowserLocalCacheUserScopeClearResult> => {
  const normalizedUserScope = String(userScope || '').trim()
  const storeCounts: Partial<Record<BrowserLocalCacheStoreName, number>> = {}
  if (!normalizedUserScope) {
    return {
      userScope: '',
      deletedCount: 0,
      storeCounts,
    }
  }

  let deletedCount = 0
  for (const storeName of BROWSER_LOCAL_CACHE_USER_SCOPED_STORES) {
    const removed = await driver.clearUserScope(storeName, normalizedUserScope)
    storeCounts[storeName] = removed
    deletedCount += removed
  }
  return {
    userScope: normalizedUserScope,
    deletedCount,
    storeCounts,
  }
}
